export default __webpack_public_path__ + "static/media/habano-1Open.5e77e8c1.jpg";